import { withFormik } from 'formik'

import CoachingCertificateChunk                  from './chunks/CoachingCertificateChunk'
import { genValueMapper, proxyFormikSubmission } from './form-utils'
import { asFormStep }                            from './wrappers'

const formik = {
  handleSubmit:     proxyFormikSubmission,
  mapPropsToValues: genValueMapper({ coachingCertificates: [] }),
}

export default withFormik(formik)(asFormStep(CoachingCertificateChunk))



// WEBPACK FOOTER //
// ./src/components/forms/CoachingCertificatesFormStep.tsx